import React, { createContext, useContext } from "react";
import { getDefaultDialCodeFromUserTimezone } from "repoV2/features/Common/modules/Timezone/Timezone.utils";
import { ICheckoutCreatorDetails } from "../utils/apis/CreatorDetailsApi/ICreatorDetailsApi.interface";

interface ICheckoutFormContext {
    isGstEnabled?: boolean | null;
    isUserEmailMandatory?: boolean | null;
    isBillingStateMandatory?: boolean | null;
    defaultCountryCode?: string;
}

interface ICheckoutFormContextProvider {
    creatorDetails: ICheckoutCreatorDetails;
    children?: JSX.Element | JSX.Element[];
}

const initialContext: ICheckoutFormContext = {
    isGstEnabled: null,
    isUserEmailMandatory: null,
    isBillingStateMandatory: null,
};

const CheckoutFormContext = createContext(initialContext);

const CheckoutFormContextProvider: React.FC<ICheckoutFormContextProvider> =
    props => {
        const { children, creatorDetails } = props;
        const {
            get_gst_info: isGstEnabled = false,
            is_email_non_mandatory_for_booking = false,
            billing_state_non_mandatory = false,
        } = creatorDetails;

        const isUserEmailMandatory = !is_email_non_mandatory_for_booking;
        const isBillingStateMandatory = !billing_state_non_mandatory;
        const defaultCountryCode = getDefaultDialCodeFromUserTimezone();

        // @dev any initial processing (that does not change after mount)
        // on form specific data will happen here.
        return (
            <CheckoutFormContext.Provider
                value={{
                    isGstEnabled,
                    isUserEmailMandatory,
                    isBillingStateMandatory,
                    defaultCountryCode,
                }}
            >
                {children}
            </CheckoutFormContext.Provider>
        );
    };

export const useCheckoutFormContext = () => {
    return useContext(CheckoutFormContext);
};

export default CheckoutFormContextProvider;
